import { render, staticRenderFns } from "./UpdatesList.vue?vue&type=template&id=f4502b7c&scoped=true"
import script from "./UpdatesList.vue?vue&type=script&lang=js"
export * from "./UpdatesList.vue?vue&type=script&lang=js"
import style0 from "./UpdatesList.vue?vue&type=style&index=0&id=f4502b7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4502b7c",
  null
  
)

export default component.exports